import apiClient from './client.ts';
import { APP_CONSTANTS_API } from './config.ts';
import { StatementCommand, StatementResult, Employee, BookingSession, SendBookingRequestCommand, GetAllBookingSessionsResult, GetAllEmployeesResult, GetAllBookingSessionsCommand, GetAllPromotionsResult, GetAllProjectsResult, GetAllServicesResult, GetAllAddressesResult, GetAllReviewsResult, CreateReviewRequestCommand, GetAllFAQResult } from './types';

export const submitStatement = async (command: StatementCommand): Promise<StatementResult> => {
  const response = await apiClient.post<StatementResult>(APP_CONSTANTS_API.STATEMENT, command);
  return response.data;
};

export const AllEmployeesQuery = async (AddressId: number): Promise<GetAllEmployeesResult> => {
  const response = await apiClient.get<GetAllEmployeesResult>(APP_CONSTANTS_API.EMPLOYEESS, { params: { AddressId } });
  return response.data;
};

export const GetAllBookingSessions = async (command: GetAllBookingSessionsCommand): Promise<GetAllBookingSessionsResult> => {
  const response = await apiClient.get<GetAllBookingSessionsResult>(APP_CONSTANTS_API.BOOKINGSEESSIONS, {
    params: { EmployeeId: command.EmployeeId, Year: command.Year, Month: command.Month }
  });
  return response.data;
};

export const SendBookingRequest = async (command: SendBookingRequestCommand): Promise<SendBookingRequestCommand> => {
  const response = await apiClient.post(APP_CONSTANTS_API.SESSIONSREQUESTS, command);
  return response.data;
};

export const GetAllPromotions = async (): Promise<GetAllPromotionsResult> => {
  const response = await apiClient.get<GetAllPromotionsResult>(APP_CONSTANTS_API.PROMOTIONS);
  return response.data;
};
export const GetAllProjects = async (): Promise<GetAllProjectsResult> => {
  const response = await apiClient.get<GetAllProjectsResult>(APP_CONSTANTS_API.PROJECTS);
  return response.data;
};
export const GetAllServices = async (): Promise<GetAllServicesResult> => {
  const response = await apiClient.get<GetAllServicesResult>(APP_CONSTANTS_API.SERVICES);
  return response.data;
};
export const getAllAddresses = async (): Promise<GetAllAddressesResult> => {
  const response = await apiClient.get<GetAllAddressesResult>(APP_CONSTANTS_API.ADDRES);
  return response.data;
};
export const getAllReviews = async (): Promise<GetAllReviewsResult> => {
  const response = await apiClient.get<GetAllReviewsResult>(APP_CONSTANTS_API.REVIEW);
  return response.data;
};
export const SendReviewRequest = async (command: CreateReviewRequestCommand) => {
  const response = await apiClient.post(APP_CONSTANTS_API.REVIEWREQUEST, command);
  return response.data;
};
export const visitAnalytics = async () => {
  const response = await apiClient.post(APP_CONSTANTS_API.VISITANALUTICS);
  return response.data;
};
export const getAllFAQ = async (): Promise<GetAllFAQResult> => {
  const response = await apiClient.get<GetAllFAQResult>(APP_CONSTANTS_API.FAQ);
  return response.data;
};

